<template>
  <div v-loading.fullscreen.lock="isLoading"></div>
</template>
<script>
export default {
  data() {
    return {
      pddApi: require("@/api/pdd/mall").default,
      isLoading: false,
    }
  },
  mounted() {
    // console.log("route", this.$route);
    if (this.$route.query.code) {
      this.isLoading = true;
      var code = this.$route.query.code;
      this.pddApi.codelogin(code).then(res => {
        this.isLoading = false;
        if (res.errorCode) {
          this.$message.error(res.errorMessage);
        } else {
          localStorage.setItem("sys_type", "pdd");
          localStorage.setItem("token", res.accessToken);
          localStorage.setItem("user-info", JSON.stringify({
            logo: res.logoUrl,
            userName: res.userName,
            mallId: res.mallId,
            mallName: res.mallName,
            mainType: res.mainType,
            secretKey: res.secretKey,
            expirationDate: this.$commonJs.toDateString(res.expirationDate)
          }));
          var mall_list = [];
          if (res.mallInfos) {
            res.mallInfos.forEach(x => {
              mall_list.push({ logo: x.logoUrl, mallId: x.mallId, mallName: x.mallName, mainType: res.mainType, secretKey: x.secretKey, expirationDate: this.$commonJs.toDateString(x.expirationDate) })
            })
          } else {
            mall_list.push({ logo: res.logoUrl, mallId: res.mallId, mallName: res.mallName, mainType: res.mainType, secretKey: res.secretKey, expirationDate: this.$commonJs.toDateString(res.expirationDate) })
          }
          localStorage.setItem("mall_list", JSON.stringify(mall_list));

          this.$router.push("/");
        }
      }).catch(err => {
        this.isLoading = false;
        console.log("err", err);
        if (process.env.NODE_ENV != "development") {
          var redirect_uri = "http://auth.honghuds.com/HHPddAuth/PrintAuth"
          window.location.href = "https://fuwu.pinduoduo.com/service-market/auth?response_type=code&client_id=e92831518a3b4432a8576b6cc1639afd&redirect_uri=" + redirect_uri;
        }
      })
    } else {
      if (process.env.NODE_ENV != "development") {
        var redirect_uri = "http://auth.honghuds.com/HHPddAuth/PrintAuth"
        window.location.href = "https://fuwu.pinduoduo.com/service-market/auth?response_type=code&client_id=e92831518a3b4432a8576b6cc1639afd&redirect_uri=" + redirect_uri;
      }
    }
  },
  methods: {

  }
}

</script>